import { render, staticRenderFns } from "./ListForm.vue?vue&type=template&id=0330c0b4&scoped=true&"
import script from "./ListForm.vue?vue&type=script&lang=js&"
export * from "./ListForm.vue?vue&type=script&lang=js&"
import style0 from "./ListForm.vue?vue&type=style&index=0&id=0330c0b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0330c0b4",
  null
  
)

export default component.exports